import {
SET_HEADER_BUTTONS
} from '../constants/headerButtonsConstants';


//SET HEADER BUTTONS
export function setHeaderButtons(data) {
    return {
        type: SET_HEADER_BUTTONS,
        data
    }
};

export function SetHeaderButtons(data) {
    return dispatch => {
        dispatch(setHeaderButtons(data));
    }
};
